module.exports = __webpack_public_path__ + "static/22-derby-4d7c7064ff6fdb7f87f90f80e665fbcb.png";